import { makeEntityScaffold } from '@classpass/saga-tools';
import { isEmpty } from 'helpers/verify';

const IMMEDIATELY = 'immediately';

export const createSubscription = makeEntityScaffold(
  'SAGA.API.CREATE_SUBSCRIPTION',
  (
    client,
    { consents, conversion, effective, giftCode, livePlanId, locationId, msaId, planId, stripeToken, userId }
  ) => {
    const payload = {
      effective: effective || IMMEDIATELY,
      msa_id: parseInt(msaId, 10),
      plan_id: planId,
      ...(consents && { consents }),
      ...(conversion && !isEmpty(conversion) && { conversion }),
      ...(giftCode && { redemption_code: giftCode }),
      ...(livePlanId && { digital_plan_id: livePlanId }),
      ...(locationId && { gls_location_id: locationId }),
      ...(stripeToken && { payment_token: stripeToken }),
    };

    return client.subscription.create(userId, payload);
  }
);

export const createSubscriptionCache = makeEntityScaffold(
  'SAGA.API.CREATE_SUBSCRIPTION_CACHE',
  (client, userId, payload) => client.subscription.createCache(userId, payload)
);

// This will suffice for most cases where you need the user's subscription.
// If you need the four last digits of the user's card, please use the `userBillingDetails` entity.
// Calling the endpoint with extended: true results in calls to the Stripe API and is significantly slower.
export const userSubscription = makeEntityScaffold('SAGA.API.SUBSCRIPTION', (client, userId) =>
  client.subscription.getLegacy(userId, { extended: false }).then(data => data.data)
);

export const redeemSubscriptionCode = makeEntityScaffold(
  'SAGA.API.REDEEM_SUBSCRIPTION_CREDIT',
  (client, userId, code) =>
    client.subscription.redeem(userId, {
      redemption_code: code,
    }),
  { defaultKey: 1 }
);

export const redeemOffer = makeEntityScaffold('SAGA.API.SUBSCRIPTION.REDEEM_OFFER', (client, userId, params) =>
  client.subscription.redeemOffer(userId, params)
);

export const revokeCancellation = makeEntityScaffold('SAGA.API.SUBSCRIPTION.REVOKE_CANCELLATION', (client, userId) =>
  client.subscription.revokeCancellation(userId)
);

export const cancelSubscription = makeEntityScaffold(
  'SAGA.API.SUBSCRIPTION.CANCEL',
  (client, { effective = 'next-cycle', userId }) =>
    client.subscription.update(userId, {
      action: 'cancel',
      effective,
    })
);
export const liveSubscription = makeEntityScaffold('SAGA.API.LIVE_SUBSCRIPTION', client =>
  client.subscription.getLive()
);
